var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ice-pop-selector" },
    [
      _vm.label && _vm.mode != "hidden"
        ? _c(
            "ice-label",
            { attrs: { name: _vm.label, width: _vm.labelWidth } },
            [
              _c(
                "el-input",
                {
                  staticStyle: { display: "inline-block" },
                  attrs: {
                    placeholder: _vm.mode == "readonly" ? "" : _vm.title,
                    clearable: _vm.mode != "readonly",
                    readonly:
                      _vm.mode == "readonly" || _vm.mode == "onlySelect",
                    disabled: _vm.mode == "readonly",
                  },
                  model: {
                    value: _vm.selectedValue,
                    callback: function ($$v) {
                      _vm.selectedValue = $$v
                    },
                    expression: "selectedValue",
                  },
                },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.selectedValue && _vm.isShowClear,
                          expression: "selectedValue && isShowClear",
                        },
                      ],
                      attrs: { slot: "suffix" },
                      on: { click: _vm.btnClearable },
                      slot: "suffix",
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-circle-close",
                        staticStyle: {
                          margin: "11px 3px 0 0",
                          cursor: "pointer",
                        },
                      }),
                    ]
                  ),
                  _vm.mode != "readonly"
                    ? _c("el-button", {
                        attrs: { slot: "append", icon: _vm.icon },
                        on: { click: _vm.openDialog },
                        slot: "append",
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      !_vm.label && _vm.mode != "hidden"
        ? _c(
            "el-input",
            {
              staticClass: "ice-pop-selector-input",
              attrs: {
                placeholder: _vm.mode == "readonly" ? "" : _vm.title,
                clearable: _vm.mode != "readonly",
                readonly: _vm.mode == "readonly" || _vm.mode == "onlySelect",
                disabled: _vm.mode == "readonly",
              },
              model: {
                value: _vm.selectedValue,
                callback: function ($$v) {
                  _vm.selectedValue = $$v
                },
                expression: "selectedValue",
              },
            },
            [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.selectedValue && _vm.isShowClear,
                      expression: "selectedValue && isShowClear",
                    },
                  ],
                  attrs: { slot: "suffix" },
                  on: { click: _vm.btnClearable },
                  slot: "suffix",
                },
                [
                  _c("i", {
                    staticClass: "el-icon-circle-close",
                    staticStyle: { margin: "11px 3px 0 0", cursor: "pointer" },
                  }),
                ]
              ),
              _vm.mode != "readonly"
                ? _c("el-button", {
                    staticStyle: { position: "relative" },
                    attrs: { slot: "append", icon: _vm.icon },
                    on: { click: _vm.openDialog },
                    slot: "append",
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.mode != "readonly"
        ? _c(
            "el-dialog",
            {
              directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
              staticClass: "ice-pop-selector-dialog",
              attrs: {
                title: _vm.title,
                center: "",
                "before-close": _vm.selectCannel,
                visible: _vm.visible,
                width: _vm.dialogWidth + "px",
                "modal-append-to-body": false,
                "append-to-body": true,
                "lock-scroll": true,
                "close-on-click-modal": false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.visible = $event
                },
              },
            },
            [
              _c(
                "div",
                {
                  style: {
                    height: _vm.height + "px",
                    display: "flex",
                    "flex-direction": "row",
                  },
                },
                [
                  _vm._t("default", [
                    (_vm.$attrs.dataUrl || _vm.$attrs["data-url"]) &&
                    (_vm.$attrs.loadUrl || _vm.$attrs["load-url"])
                      ? _c(
                          "ice-tree-grid",
                          _vm._g(
                            _vm._b(
                              {
                                ref: "queryTreeGridPop",
                                attrs: {
                                  title: "",
                                  "columns-number": 2,
                                  "selected-codes": _vm.selectedItems.map(
                                    function (item) {
                                      return item[_vm.codeProp]
                                    }
                                  ),
                                  "choose-item": _vm.chooseItem,
                                },
                                on: { "selection-change": _vm.selectChange },
                              },
                              "ice-tree-grid",
                              _vm.$attrs,
                              false
                            ),
                            _vm.$listeners
                          )
                        )
                      : _c(
                          "ice-query-grid",
                          _vm._g(
                            _vm._b(
                              {
                                ref: "queryGridPop",
                                attrs: {
                                  resize: false,
                                  "columns-number": 2,
                                  "selected-codes": _vm.selectedItems.map(
                                    function (item) {
                                      return item[_vm.codeProp]
                                    }
                                  ),
                                  "choose-item": _vm.chooseItem,
                                },
                                on: {
                                  dbClick: _vm.dbclick,
                                  "selection-change": _vm.selectChange,
                                },
                              },
                              "ice-query-grid",
                              _vm.$attrs,
                              false
                            ),
                            _vm.$listeners
                          )
                        ),
                    _vm.chooseItem == "multiple"
                      ? _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.selectedItems.length,
                                expression: "selectedItems.length",
                              },
                            ],
                            staticClass: "selected-list",
                            style: { width: _vm.selectListWidth },
                          },
                          [
                            _vm._t(
                              "selectedList",
                              [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(
                                    "已选列表(" +
                                      _vm._s(_vm.selectedItems.length) +
                                      ")"
                                  ),
                                ]),
                                _c(
                                  "vue-scroll",
                                  {
                                    attrs: {
                                      ops: {
                                        bar: { background: "#fff", opacity: 0 },
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "tags-wrapper" },
                                      [
                                        _vm._l(
                                          _vm.filteredSelectedItems,
                                          function (tag) {
                                            return _c(
                                              "div",
                                              {
                                                key: tag.value,
                                                staticStyle: { margin: "4px" },
                                              },
                                              [
                                                _c(
                                                  "el-tag",
                                                  {
                                                    staticStyle: {
                                                      background: "#fffeee",
                                                    },
                                                    attrs: { closable: "" },
                                                    on: {
                                                      close: function ($event) {
                                                        return _vm.closeTag(
                                                          tag[_vm.codeProp]
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "text",
                                                        attrs: {
                                                          title:
                                                            tag[_vm.textProp] +
                                                            "{" +
                                                            tag[_vm.codeProp] +
                                                            "}",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              tag[_vm.textProp]
                                                            ) +
                                                            " (" +
                                                            _vm._s(
                                                              tag[_vm.codeProp]
                                                            ) +
                                                            ") "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        _vm.selectedItems.length > 100 &&
                                        !_vm.showTotal
                                          ? _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  width: "100%",
                                                  display: "flex",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    staticStyle: {
                                                      margin: "auto",
                                                    },
                                                    attrs: { type: "text" },
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.showTotal = true
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("查看全部 ")]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                              ],
                              { selectedItems: _vm.selectedItems }
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]),
                ],
                2
              ),
              _c(
                "div",
                {
                  staticClass: "ice-center-button-bar",
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end",
                    "align-items": "center",
                  },
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        icon: "el-icon-circle-close",
                        unauth: "",
                      },
                      on: { click: _vm.selectCannel },
                    },
                    [_vm._v("取消 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "el-icon-position",
                        disabled:
                          _vm.selectedItems.length <= 0 && _vm.buttonDisabled,
                        unauth: "",
                      },
                      on: { click: _vm.selectConfirm },
                    },
                    [_vm._v(" 确认 ")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }